import * as THREE from 'three'

export default function createRenderer({ canvas, sizes })
{
  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,
  })

  renderer.shadowMap.enabled = true
  renderer.shadowMap.type = THREE.PCFSoftShadowMap

  renderer.toneMapping = THREE.ACESFilmicToneMapping
  renderer.toneMappingExposure = 1

  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(sizes.pixelRatio)

  const resize = () =>
  {
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(sizes.pixelRatio)
  }

  
  const render = (scene, camera) =>
  {
    renderer.render(scene, camera)
  }

  return { renderer, resize, render }
}
